<template lang="pug">
input.cadastro-form-input(
  :type="type"
  :value="value"
  :placeholder="placeholder"
  :disabled="disabled"
  :maxlength="maxlength"
  @input="$emit('input', $event.target.value)"
)
</template>

<script>
export default {
  name: 'CadastroFormInput',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: [String, Number],
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.cadastro-form-input {
  background: #ffffff;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  color: #141414;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  height: 40px;
  line-height: 1.43;
  padding: 4px 12px;
  width: 100%;

  &::placeholder {
    color: #8a8a8a;
    opacity: 0.5;
  }

  &:disabled {
    background: #f5f5f5;
    cursor: not-allowed;
    opacity: 0.7;
  }

  &:focus {
    border-color: #1e174e;
    outline: none;
  }
}
</style>
